// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"_o-z","imageAndVideoCount":"ap-z","imageAndVideoContainer":"bp-z","viewAllReviews":"cp-z"};